// LanguageContext.js
import React, { createContext, useState, useEffect } from "react";

// Criação do contexto
export const LanguageContext = createContext();

// Componente provedor que irá envolver a aplicação
export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState("en");

    useEffect(() => {
        document.documentElement.lang = language === "pt" ? "pt-BR" : "en";
    }, [language]);

    // Função para alterar o idioma
    const changeLanguage = (newLanguage) => {
        setLanguage(newLanguage);
        document.documentElement.lang = newLanguage === "pt" ? "pt-BR" : "en";
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
